import { ReduxAction, ReduxDispatch } from '../../../Configs/Redux/Types';
import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { httpGetWithDispatch } from '../../../__core/Providers/HttpClient/HttpCallerWithDispatch';
import {
  getCoursesListSuccess,
  getProductsListSuccess,
} from './ActionCreators';
import { ProductsListResponse } from '../Types/ProductsListResponse';
import HttpClient from '../../../__core/Providers/HttpClient/HttpClientInstance';

export function fetchCoursesList(
  values: Record<string, unknown> | null
): ReduxAction<Promise<unknown>> {
  const url = 'course_instances';

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    const successDispatch = (response: unknown): void => {
      dispatch(
        getCoursesListSuccess(
          response as IApiJsonResponse<Array<ICourseInstance>>
        )
      );
    };

    return httpGetWithDispatch(dispatch, url, values, successDispatch);
  };
}

export function fetchProductsList(): ReduxAction<Promise<unknown>> {
  const url = 'user/direct-access/list';

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    const successDispatch = (response: unknown): void => {
      dispatch(getProductsListSuccess(response as ProductsListResponse));
    };

    return httpGetWithDispatch(dispatch, url, null, successDispatch);
  };
}

export function setWelcomePageRedirect(
  userId: number,
  show: boolean
): Promise<unknown> {
  const url = `user/${userId}/welcome-page`;

  const form = new URLSearchParams();
  form.append('show', String(show));

  return new Promise<unknown>((resolve, reject) =>
    HttpClient.put(url, form).then(resolve).catch(reject)
  );
}
